module.exports = __webpack_public_path__ + "static/media/posture.d44b6a04.png";